import '../LandingPage/LandingPage.scss';
import { Grid } from '@mui/material';
import dataPipelineLogo from '../../assets/data-pipeline-logo.svg';

import CustomDashboardIcon from '../../assets/Custom Dashboard_Small.svg';
import { useEffect, useState, lazy } from 'react';
import landingBackArrow from '../../assets/landingBackArrow.svg';
import { usePepwiseAuthController } from 'Context/contexts/AuthContext';
import { useTheme } from "@mui/material/styles";
import PlatformHealth from '../../assets/PepWise2.0/Platform_health_Selected_White.svg';
import PipelineRunStatus from '../../assets/PepWise2.0/Pipeline Run Status_White.svg';
import { RESTRICTED_ROLE_NAMES } from 'utils/common-util';
import { checkRole } from 'utils/roleUtils';

// Lazy load components
const Header = lazy(() => import('./Header'));
const Footer = lazy(() => import('../LandingPage/ModuleLandingFooter'));
const capabilitiesNew: any = localStorage.getItem('capabilities');


export default function DataopsLanding() {
	const theme = useTheme();
	const colors = theme.palette;
	const [, setMemberData] = useState<any>(null);
	const [controller, _] = usePepwiseAuthController();
	const { accessToken, role } = controller;
	console.log(capabilitiesNew, 'capabilitiesNew==')
	const capabilitiesArray = capabilitiesNew ? capabilitiesNew.split(',') : [];

	const isRestricted = checkRole(role, RESTRICTED_ROLE_NAMES);

	// to display data
	useEffect(() => {
		setMemberData(accessToken);
	}, []);

	//navigate to data-pipeline observability
	const handleDataPipelineClick = (event: any, type: string, url: string) => {
		event.preventDefault(); // Prevent the default context menu from showing up
		if (type === 'blank') {
			// Open the URL in a new tab if type is 'blank'
			window.open(url, '_blank');
		} else {
			// Navigate to the provided URL in the current tab
			window.location.href = url;
		}
	};

	const handleBackClick = () => {
		window.location.href = '/LandingPage';
	};


	return (
		<div className="outerLandingPageContainer" style={{ backgroundColor: `${colors.backgroundLight.primary}` }}>
			{/* <Header memberData={memberData} /> */}
			<div style={{ maxWidth: '86%', margin: '0 auto' }}>
				<div className="landingMessage-container">
					<img src={landingBackArrow} alt="CCLogo" className="landingMessageImage" onClick={handleBackClick} />
					<p className="landingMessage" style={{ color: `${colors.textLight.secondary}` }}>{`Data Pipeline Observability`}</p>
				</div>


				<div className="welcome_text">
					<p style={{ color: `${colors.textLight.secondary}` }}>Click on the module below to monitor!</p>
				</div>
				<Grid container spacing={1} style={{ marginTop: '0px' }}>
					{capabilitiesArray.includes('Data Ops') ? (
						<Grid
							item
							xs={4}
							style={{ cursor: 'pointer' }}
							onClick={(e) => handleDataPipelineClick(e, 'no-blank', '/data-pipeline/dataOps')}
							onContextMenu={(e) => {
								e.preventDefault();
								handleDataPipelineClick(e, 'blank', '/data-pipeline/dataOps');
							}}
						>
							<div className="observalbility_screens" style={{ textAlign: 'center' }}>
								<div className="title">
									<img src={dataPipelineLogo} alt="tableauLogo" className="obs_logo" style={{ display: 'block', margin: '0 auto' }} />
								</div>
								<div>
									<h3 className="obsTitle" style={{ margin: '10px 0' }}>
										DataOps Sustain
									</h3>
								</div>
								<p
									className="message1"
									title="Monitor jobs or pipelines for a specific project."
									style={{ margin: '0', textAlign: 'center' }}
								>
									Monitor jobs or pipelines for a specific project.
								</p>
							</div>
						</Grid>
					) : (
						''
					)}
					{(capabilitiesArray.includes('Data Ops') && !isRestricted) ? (
						<Grid
							item
							xs={4}

							onClick={(e) => handleDataPipelineClick(e, 'no-blank', '/data-pipeline/programOpsDashboard')}
							onContextMenu={(e) => {
								e.preventDefault();
								handleDataPipelineClick(e, 'blank', '/data-pipeline/programOpsDashboard');
							}}
						>
							<div className="observalbility_screens" style={{ textAlign: 'center' }}>
								<div className="title">
									<img src={CustomDashboardIcon} alt="tableauLogo" className="obs_logo" style={{ display: 'block', margin: '0 auto' }} />
								</div>
								<div>
									<h3 className="obsTitle" style={{ margin: '10px 0' }}>
										Program Ops Dashboards
									</h3>
								</div>
								<p
									className="message1"
									title="Observe custom Grafana dashboards."
									style={{ margin: '0', textAlign: 'center' }}
								>
									Observe custom Grafana dashboards.
								</p>
							</div>
						</Grid>
					) : (
						''
					)}
					{(capabilitiesArray.includes('Data Ops') && !isRestricted) ? (
						<Grid
							item
							xs={4}

							onClick={(e) => handleDataPipelineClick(e, 'no-blank', '/data-pipeline/home/executiveOps')}
							onContextMenu={(e) => {
								e.preventDefault();
								handleDataPipelineClick(e, 'blank', '/data-pipeline/home/executiveOps');
							}}
						>
							<div className="observalbility_screens" style={{ textAlign: 'center' }}>
								<div className="title">
									<img src={dataPipelineLogo} alt="tableauLogo" className="obs_logo" style={{ display: 'block', margin: '0 auto' }} />
								</div>
								<div>
									<h3 className="obsTitle" style={{ margin: '10px 0' }}>
										End to End Observability Dashboard
									</h3>
								</div>
								<p
									className="message1"
									title="across all workflows"
									style={{ margin: '0', textAlign: 'center' }}
								>
									Monito jobs or pipelines for a specific project.
								</p>
							</div>
						</Grid>
					) : (
						''
					)}
					{capabilitiesArray.includes('Data Ops') ? (
						<Grid
							item
							xs={4}

							onClick={(e) => handleDataPipelineClick(e, 'no-blank', '/dataOps/platformHealth/summary')}
							onContextMenu={(e) => {
								e.preventDefault();
								handleDataPipelineClick(e, 'blank', '/dataOps/platformHealth/summary');
							}}
						>
							<div className="observalbility_screens" style={{ textAlign: 'center' }}>
								<div className="title">
									<img src={PlatformHealth} alt="tableauLogo" className="obs_logo" style={{ display: 'block', margin: '0 auto' }} />
								</div>
								<div>
									<h3 className="obsTitle" style={{ margin: '10px 0' }}>
										Platform Health Dashboard
									</h3>
								</div>
								<p
									className="message1"
									title="Monitor platform health across all workflows"
									style={{ margin: '0', textAlign: 'center' }}
								>
									Monitor platform health across PepsiCo for performance,growth and usage.
								</p>
							</div>
						</Grid>
					) : (
						''
					)}

					{capabilitiesArray.includes('Data Ops') ? (
						<Grid
							item
							xs={4}
							style={{ cursor: 'pointer' }}
							onClick={(e) => handleDataPipelineClick(e, 'no-blank', '/dataops/unified-alerts')}
							onContextMenu={(e) => {
								e.preventDefault();
								handleDataPipelineClick(e, 'blank', '/dataops/unified-alerts');
							}}
						>
							<div className="observalbility_screens" style={{ textAlign: 'center' }}>
								<div className="title">
									<img src={dataPipelineLogo} alt="tableauLogo" className="obs_logo" style={{ display: 'block', margin: '0 auto' }} />
								</div>
								<div>
									<h3 className="obsTitle" style={{ margin: '10px 0' }}>
										Pipeline Early Warning System
									</h3>
								</div>
								<p
									className="message1"
									title="Monitor pipeline health across Pepsico for the alerts and early notifications."
									style={{ margin: '0', textAlign: 'center' }}
								>
									Monitor pipeline health across Pepsico for the alerts and early notifications.
								</p>
							</div>
						</Grid>
					) : (
						''
					)}

					{capabilitiesArray.includes('Data Ops') ? (
						<Grid
							item
							xs={4}

							onClick={(e) => handleDataPipelineClick(e, 'no-blank', '/dataOps/pipelineRunStatus')}
							onContextMenu={(e) => {
								e.preventDefault();
								handleDataPipelineClick(e, 'blank', '/dataOps/pipelineRunStatus');
							}}
						>
							<div className="observalbility_screens" style={{ textAlign: 'center' }}>
								<div className="title">
									<img src={PipelineRunStatus} alt="tableauLogo" className="obs_logo" style={{ display: 'block', margin: '0 auto' }} />
								</div>
								<div>
									<h3 className="obsTitle" style={{ margin: '10px 0' }}>
										Integrated Job Monitoring Dashboard
									</h3>
								</div>
								<p
									className="message1"
									title="Realtime tracking of pipeline runs."
									style={{ margin: '0', textAlign: 'center' }}
								>
									Realtime tracking of pipeline runs.
								</p>
							</div>
						</Grid>
					) : (
						''
					)}
				</Grid>
			</div>
			<Footer />
		</div>
	);
}
